// API
import { apiFetch } from '../../app/apiFetch';

/**
 * @function fetchSessions
 * Returns a list of sessions to display in the lobby
 *
 * @return {array} Session[]
 */
export function fetchSessions() {
    const endpoint = '/v1/session/lobby';

    return apiFetch('POST', endpoint);
}
